const themes = {
  // light: {
  //   white: "#FFFFFF",
  //   lightest: "#FAFBFF",
  //   lighter: "#F3F5F9",
  //   primary: "#500fe9",
  //   primary_back_light: "#ede7fd",
  //   primary_light: "#5e15ef",
  //   secondary: "#40DDD5",
  //   secondary_light: "#43e8e0",
  //   black: "#000022",
  //   darker: "#768391",
  //   darkest: "#56606B",
  //   error: "#ec484a",
  //   info: "#3889d0",
  //   success: "#00b947",
  //   warning: "#eb8149"
  // },
  // dark: {
  //   white: "#FFFFFF",
  //   lightest: "#FAFBFF",
  //   lighter: "#F3F5F9",
  //   primary: "#e90fd7",
  //   primary_back_light: "#ede7fd",
  //   primary_light: "#5e15ef",
  //   secondary: "#40DDD5",
  //   secondary_light: "#43e8e0",
  //   black: "#000022",
  //   darker: "#768391",
  //   darkest: "#56606B",
  //   error: "#ec484a",
  //   info: "#3889d0",
  //   success: "#00b947",
  //   warning: "#eb8149"
  // }
  dark: {
    primary: "#815BFF",
    primaryHover: "#6749CC",
    primary1: "#242D36",
    primary2: "#A680FF",
    primary3: "#2A2A4C",
    primary4: "#21263B",
    primary5: "#222A33",
    primary6: "#2B333B",
    primary7: "#3E444C",
    primaryX: "#D6C7FE",
    onPrimary: "#FFFFFF",
    secondary: "#40DDD5",
    secondaryHover: "#3BCCC5",
    white: "#ffffff",
    gray1: "#DFE0E2",
    gray2: "#9EA1A5",
    gray3: "#848E9C",
    gray4: "#3B424D",
    gray5: "#313841",
    gray6: "#2F363E",
    gray7: "#2A313A",
    gray8: "#282F38",
    gray9: "#232A33",
    gray10: "#202831",
    gray11: "#1E252F",
    gray12: "#19212A",
    gray13: "#0D151F",
    black: "#000000",
    field: "#2F3842",
    fieldBG: "#2F3842",
    snackbar: "#2F3842",
    background: "#19212A",
    modal: "#2F3842",
    bottomSheet: "#2F3842",
    success: "#02C076",
    successTransparent: "#163a36",
    info: "#2E9DFF",
    infoTransparent: "#1c364b",
    warning: "#F18F01",
    warningTransparent: "#3c3324",
    error: "#F84960",
    errorTransparent: "#3d2733"
  },
  light: {
    primary: "#500FE9",
    primaryHover: "#5E15EF",
    primary1: "#F6F3FE",
    primary2: "#E5E3F9",
    primary3: "#DBD5F8",
    primary4: "#C4C8CE",
    primary5: "#CDD1D7",
    primary6: "#D2D6DB",
    primary7: "#D7DAE0",
    primaryX: "#500FE9",
    onPrimary: "#FFFFFF",
    secondary: "#40DDD5",
    secondaryHover: "#3BCCC5",
    white: "#ffffff",
    gray1: "#0D151F",
    gray2: "#7F858D",
    gray3: "#969BA2",
    gray4: "#CDD1D7",
    gray5: "#D0D3D9",
    gray6: "#D2D6DB",
    gray7: "#EDF1F7",
    gray8: "#F3F5F9",
    gray9: "#F7FAFC",
    gray10: "#FFFFFF",
    gray11: "#F0F4F7",
    gray12: "#E7EAEF",
    gray13: "#F2F5FA",
    black: "#000000",
    field: "#E7EAEF",
    fieldBG: "#FAFBFC",
    snackbar: "#0D151F",
    background: "#F3F5F9",
    modal: "#FFFFFF",
    bottomSheet: "#FFFFFF",
    success: "#00B947",
    successTransparent: "#ccebde",
    info: "#3889D0",
    infoTransparent: "#d4e4f2",
    warning: "#F18F01",
    warningTransparent: "#f2e5d3",
    error: "#EC484A",
    errorTransparent: "#f1d9de"
  }
};
export default themes;
